<script lang="ts">
    import IconDelete from "./icons/IconDelete.svelte";
import IconKara from "./icons/IconKara.svelte";
    import IconLeaf from "./icons/IconLeaf.svelte";
    import IconMushroom from "./icons/IconMushroom.svelte";
    import IconTree from "./icons/IconTree.svelte";
    import { EditModeWorld } from "./state/state";
    import Kara from "./world/kara.svelte";
    import type { World } from "./world/world";
    import CWorld from "./world/world.svelte";

    export let world: World;
    export let onWorldChange: (world: World) => void;

    function handleWorldChange(newWorld: World) {
        onWorldChange(newWorld);
    }

    let editModeWorld = EditModeWorld.KARA;

    function handleKaraClick() {
        editModeWorld = EditModeWorld.KARA;
    }

    function handleLeafClick() {
        editModeWorld = EditModeWorld.LEAF;
    }

    function handleTreeClick() {
        editModeWorld = EditModeWorld.TREE;
    }

    function handleMushroomClick() {
        editModeWorld = EditModeWorld.MUSHROOM;
    }

    function handleDeleteClick() {
        editModeWorld = EditModeWorld.DELETE;
    }
</script>

<div style="display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column;"> 
        <button 
            class:highlighted={editModeWorld === EditModeWorld.KARA}
            on:click={handleKaraClick}
        >
            <IconKara />
        </button>

        <button 
            class:highlighted={editModeWorld === EditModeWorld.LEAF}
            on:click={handleLeafClick}
        >
            <IconLeaf />
        </button>

        <button
            class:highlighted={editModeWorld === EditModeWorld.TREE}
            on:click={handleTreeClick}
        >
            <IconTree />
        </button>

        <button
            class:highlighted={editModeWorld === EditModeWorld.MUSHROOM}
            on:click={handleMushroomClick}
        >
            <IconMushroom />
        </button>

        <button
            class:highlighted={editModeWorld === EditModeWorld.DELETE}
            on:click={handleDeleteClick}
        >
            <IconDelete />
        </button>
    </div>
    <CWorld world={world} editModeWorld={editModeWorld} onWorldChange={handleWorldChange}/>
</div>

<style>
    .highlighted {
        background-color: lightblue;
    }
</style>